import React from 'react';
import PropTypes from 'prop-types';


import { connect } from 'react-redux';
import { createPlan, updatePlan } from '../store/plans/actions';

import { Button } from 'components/ui/button';
import Modal from 'components/modal';
import PlanForm from './plan';
import { isReadOnly } from './helpers';

export class CommissionPlanFormModal extends React.Component {
  static propTypes = {
    allowCohorts: PropTypes.bool,
    createPlan: PropTypes.func.isRequired,
    enabledRealCalculationModes: PropTypes.array,
    plan: PropTypes.shape({
      archived: PropTypes.bool,
      id: PropTypes.number
    }).isRequired,
    show: PropTypes.bool,
    updatePlan: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  state = {
    errors: [],
    plan: { tiers: [], resetPeriod: 1 }
  }

  componentDidUpdate(previousProps) {
    if (this.props.show && !previousProps.show) {
      this.setState({
        errors: [],
        plan: JSON.parse(JSON.stringify(this.props.plan))
      });
    }
  }

  handleChange = (changes) => {
    this.setState(({ plan }) => ({ plan: { ...plan, ...changes } }));
  }

  handleSave = async () => {
    this.setState({ errors: [] });

    const plan = { ...this.state.plan };
    if (isReadOnly(this.props.plan)) {
      delete plan.startDate;
    }

    try {
      const savePlan = this.props.plan.id ? this.props.updatePlan : this.props.createPlan;
      await savePlan(plan);
      this.props.onClose();
    } catch (errors) {
      this.setState({ errors });
      return;
    }
  }

  render() {
    const { onClose, show } = this.props;
    const { errors, plan } = this.state;

    return (
      <Modal show={show} size="lg" onHide={onClose}>
        <Modal.Header closeButton>
          Commission Plan
        </Modal.Header>

        <Modal.Body>
          <PlanForm
            allowCohorts={this.props.allowCohorts}
            enabledRealCalculationModes={this.props.enabledRealCalculationModes}
            plan={plan}
            onChange={this.handleChange}
          />
        </Modal.Body>

        <Modal.Footer>
          <span className="text-danger me-4" name="errors">
            {errors.join(', ')}
          </span>

          <Button label="Cancel" variant="ghost" onClick={onClose} />
          <Button disabled={plan.archived} name="save" onClick={this.handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  allowCohorts: state.settings.allowCohorts,
  enabledRealCalculationModes: state.settings.enabledRealCalculationModes,
});

const mapDispatchToProps = {
  createPlan,
  updatePlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(CommissionPlanFormModal);
